<div class="loading_spinner vh-100 w-100 position-fixed top-0 start-0 bg-white">
    <div class="d-flex justify-content-center align-items-center h-100">
        <div class="logo-loader-container">
            <div class="rotating-circle"></div>
            <app-logo-component></app-logo-component>
        </div>
    </div>
</div>